<template>
  <div>
    <!-- Dashboard EMS🚀 -->
    <b-row
      lg="12"
      md="12"
      sm="12"
    >
      <b-col
        lg="4"
        md="6"
        sm="12"
      >
        <statistic-card-MDB
          style="font-size:18px;
          background-color:rgba(0,0,0, 1);
          color:#ffffff;
          height: 280px; height: 280px; border: 1px solid #ffffff;
          border-radius: 20px;"
          color="light-warning"
        /></b-col>
      <b-col
        lg="4"
        md="6"
        sm="12"
      >
        <statistic-card-ATS
          style="font-size:18px; background-color:rgba(0,0,0, 1); color:#ffffff; height: 280px; border: 1px solid #ffffff; border-radius: 20px;"
          color="light-warning"
        /></b-col>
      <b-col
        lg="4"
        md="6"
        sm="12"
      >
        <statistic-card-generator
          style="font-size:18px; background-color:rgba(0,0,0, 1); color:#ffffff; height: 280px; border: 1px solid #ffffff; border-radius: 20px;"
          color="light-warning"
        /></b-col>
      <b-col
        lg="4"
        md="6"
        sm="12"
      >
        <statistic-card-elevator
          style="font-size:18px;
          background-color:rgba(0,0,0, 1);
          color:#ffffff;
          height: 280px; border: 1px solid #ffffff;
          border-radius: 20px;"
          color="light-warning"
        /></b-col>
      <b-col
        lg="4"
        md="6"
        sm="12"
      >
        <statistic-card-alarm
          style="font-size:18px; background-color:rgba(0,0,0, 1); color:#ffffff; height: 280px; border: 1px solid #ffffff; border-radius: 20px;"
          color="light-warning"
        /></b-col>
      <b-col
        lg="4"
        md="6"
        sm="12"
      >
        <statistic-card-gateway
          style="font-size:18px; background-color:rgba(0,0,0, 1); color:#ffffff; height: 280px; border: 1px solid #ffffff; border-radius: 20px;"
          color="light-warning"
        /></b-col>
    </b-row>
    <b-row>

      <!--------------- Table Alarm ----------------->
      <b-col
        md="6"
        sm="12"
        lg="6"
      >
        <template>
          <b-card-code
            style="background-color:rgba(255, 220, 220, 0.9);"
            title="Alert Notification"
          >
            <b-row>
              <!-- <b-col
                md="8"
                sm="12"
                lg="9"
                xs="12"
                class="text-sm-right mb-1"
              >
                <b-button
                  id="toggle-btn"
                  v-b-modal="'modalAdd'"
                  variant="primary"
                >
                  Add New
                </b-button>
              </b-col> -->
              <b-col cols="12">
                <b-table
                  responsive
                  :per-page="perPage"
                  :current-page="currentPage"
                  :items="items"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                >
                  <!-- <template #cell(edit)="data">
                    <b-link
                      v-b-modal="'modalEdit'"
                      @click="$refs.childref.editModal(data.item.id)"
                    ><feather-icon
                      class="text-warning"
                      icon="EditIcon"
                      size="20"
                    />{{ data.value }}
                    </b-link>
                  </template> -->

                  <template #cell(delete)="data">
                    <b-link
                      @click.prevent="remove(data.item.id)"
                    >
                      <feather-icon
                        class="text-danger"
                        icon="XSquareIcon"
                        size="20"
                      />
                      {{ data.value }}
                    </b-link>
                  </template>

                  <template #cell(status)="data">
                    <b-badge :variant="status[1][data.value]">
                      {{ status[0][data.value] }}
                    </b-badge>
                  </template>
                </b-table>
              </b-col>

            </b-row>
          </b-card-code>
        </template>
      </b-col>
      <!--------------- Table Log ----------------->
      <b-col
        md="6"
        sm="12"
        lg="6"
      >
        <template>
          <b-card
            style="background-color:rgba(255,255,255, 0.9);"
          >
            <template #header>
              <b-col
                cols="8"
                class="text-sm-left mb-0"
              >
                <h4
                  class="card-title"
                >Lora Wan Transaction
                </h4>
              </b-col>
              <b-col
                cols="4"
                class="text-sm-right mt-0"
                style="padding: 0px"
              >
                <b-button
                  v-if="gateway === 'Offline'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="danger"
                  target="_blank"
                  href="http://npt-hosp-gw1.semiothai.com"
                >
                  <feather-icon
                    size="16"
                    icon="WifiOffIcon"
                  />
                  Gateway
                </b-button>
                <b-button
                  v-if="gateway === 'Online'"
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="success"
                  target="_blank"
                  href="http://npt-hosp-gw1.semiothai.com"
                >
                  <feather-icon
                    size="16"
                    icon="WifiIcon"
                  />
                  Gateway
                </b-button>
              </b-col>
            </template>
            <b-row>
              <b-col cols="12">
                <b-table
                  responsive
                  :per-page="perPage1"
                  :current-page="currentPage1"
                  :items="items1"
                  :fields="fields1"
                  :sort-by.sync="sortBy1"
                  :sort-desc.sync="sortDesc1"
                  :sort-direction="sortDirection1"
                  :filter="filter1"
                  :filter-included-fields="filterOn1"
                  @filtered="onFilteredLog"
                >

                  <template #cell(devdesc)="data">
                    {{ data.value }} ({{ data.item.pole }})
                  </template>
                </b-table>
              </b-col>

            </b-row>
          </b-card>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BTable, BLink, BBadge, BButton,
  BCard,
  BCol,
  BRow,
} from 'bootstrap-vue'
import axios from '@axios'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import Ripple from 'vue-ripple-directive'
import StatisticCardMDB from '@core/components/statistics-cards/StatisticCardMDB.vue'
import StatisticCardATS from '@core/components/statistics-cards/StatisticCardATS.vue'
import StatisticCardGenerator from '@core/components/statistics-cards/StatisticCardGenerator.vue'
import StatisticCardElevator from '@core/components/statistics-cards/StatisticCardElevator.vue'
import StatisticCardAlarm from '@/@core/components/statistics-cards/StatisticCardFireAlarm.vue'
import StatisticCardGateway from '@core/components/statistics-cards/StatisticCardGateway.vue'

export default {
  components: {
    BCard,
    // BCardText,
    BButton,
    BTable,
    BLink,
    BBadge,
    BCardCode,
    BCol,
    BRow,
    StatisticCardMDB,
    StatisticCardATS,
    StatisticCardGenerator,
    StatisticCardElevator,
    StatisticCardAlarm,
    StatisticCardGateway,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      markers: [],
      items: [],
      building: '',
      system: '',
      reason: '',
      gateway: '',
      fields: [
        {
          key: 'date_time', label: 'Date/Time', class: 'text-left', thStyle: 'background-color: #FFBDBD',
        },
        {
          key: 'building', label: 'Building', sortable: true, class: 'text-left', thStyle: 'background-color: #FFC5C5',
        },
        {
          key: 'system_name', label: 'System', sortable: true, class: 'text-left', thStyle: 'background-color: #FFBDBD',
        },
        {
          key: 'reason', label: 'Alert', sortable: true, class: 'text-left', thStyle: 'background-color: #FFC5C5',
        },
      ],
      Total: '',
      Online: '',
      Offline: '',
      // --------history--------
      perPage: 10,
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: [{
        Offline: 'ออฟไลน์', Online: 'ออนไลน์',
      },
      {
        Offline: 'light-danger', Online: 'light-success',
      }],
      // userData: JSON.parse(localStorage.getItem('userData')),
      // Table Log //
      items1: [],
      fields1: [
        { key: 'tdate', label: 'Date/Time', class: 'text-left' },
        {
          key: 'devid', label: 'ID', sortable: true, class: 'text-left',
        },
        {
          key: 'rssi', label: 'RSSI', sortable: true, class: 'text-left',
        },
        {
          key: 'devdesc', label: 'Device', sortable: true, class: 'text-left',
        },
        {
          key: 'payload', label: 'Payload', sortable: true, class: 'text-left',
        },
      ],
      perPage1: 10,
      totalRows1: 1,
      currentPage1: 1,
      sortBy1: '',
      sortDesc1: false,
      sortDirection1: 'asc',
      filter1: null,
      filterOn1: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'User') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getAlert()
    this.getLog()
    this.getGateWay()
    this.getAlertFireAlarm()
    this.interval = setInterval(() => {
      this.getAlert()
      this.getAlertFireAlarm()
      this.getLog()
      this.getGateWay()
    }, 10000)
  },
  methods: {
    getAlert() {
      axios
        .get('/get_alertDB')
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
    },
    getGateWay() {
      axios
        .get('/get_gateway')
        .then(response => {
          this.gateway = response.data[0].status
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getLog() {
      axios
        .get('/get_logDB')
        .then(response => {
          this.items1 = response.data
          this.totalRows1 = response.data.length
        })
    },
    onFilteredLog(filteredItemsLog) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItemsLog.length
      this.currentPage1 = 1
    },
    getAlertFireAlarm() {
      axios
        .get('/get-alert')
        .then(response => {
          this.ack = response.data[0].ack
          this.building = response.data[0].building
          this.system = response.data[0].system_name
          this.reason = response.data[0].reason
          if (this.ack !== 1) {
            this.closeAlert()
            this.playSound()
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    playSound() {
      this.audio = new Audio(require('@/assets/media/alarm.mp3'))
      this.audio.play()
    },
    closeAlert() {
      this.$swal({
        title: `<span style="color:#FFA200;"> Warning </span>
        <span style="color:#000000; font-size: 20px;"> ${this.building} </span>
        <span style="color:#000000; font-size: 16px; font-weight: normal"> ระบบ ${this.system}</span>
        <span style="color:red; font-size: 16px; font-weight: normal"> (${this.reason}) </span>`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          try {
            await axios.post('/close-alertNPT', { ack: 1 })
            this.$swal({
              icon: 'success',
              title: '<span style="color:#000000">ปิดแจ้งเตือนเรียบร้อยแล้ว</span>',
              showConfirmButton: false,
              timer: 1000,
            })
          } catch (error) {
            this.$swal({
              title: 'Error!',
              text: ' Click to continue!',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.table-responsive{
   font-size: 13px;
}
.table th{
   padding: 0.72rem;
}
.table td{
   padding: 0.72rem;
}
</style>
